import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { FeatureFlagService } from '@core/services/feature-flag.service';

export const dailyChallengesFeatureMatch: CanMatchFn = () => {
  const flags = inject(FeatureFlagService);
  const router = inject(Router);
  return flags.whenKnown('dailyQuiz').pipe(
    map((enabled) => enabled || router.createUrlTree(['/'])),
  );
};
